import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { FiMessageSquare, FiX, FiSend, FiCheckCircle } from "react-icons/fi";
import { useAuth } from "../../auth/AuthContext";
import { apiPost } from "../../auth/api";
import "./feedback.css";

// Floating suggestion box. Anyone (signed in or not) can leave a message that
// only the owner reads in /admin. Local-first app, so this is the one place we
// intentionally talk to the server for non-account data.
export default function FeedbackButton() {
  const { token, email, isAuthed } = useAuth();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [guestEmail, setGuestEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | sending | done | error

  const send = async () => {
    const msg = message.trim();
    if (msg.length < 2) return;
    setStatus("sending");
    try {
      await apiPost(
        "/feedback",
        {
          message: msg,
          email: isAuthed ? email : guestEmail.trim(),
          path: location.pathname,
        },
        token
      );
      setStatus("done");
      setMessage("");
      setGuestEmail("");
      setTimeout(() => {
        setOpen(false);
        setStatus("idle");
      }, 1600);
    } catch (e) {
      setStatus("error");
    }
  };

  return (
    <div className="fb-root">
      {open && (
        <div className="fb-panel" role="dialog" aria-label="Send a suggestion">
          <div className="fb-head">
            <span>Send a suggestion</span>
            <button type="button" className="fb-x" onClick={() => setOpen(false)} aria-label="Close">
              <FiX size={16} />
            </button>
          </div>

          {status === "done" ? (
            <div className="fb-done">
              <FiCheckCircle size={28} />
              <p>Thanks! Got it.</p>
            </div>
          ) : (
            <>
              <textarea
                className="fb-text"
                placeholder="Found a bug, want a feature, or have an idea? Tell me here…"
                value={message}
                maxLength={4000}
                onChange={(e) => setMessage(e.target.value)}
                autoFocus
              />
              {!isAuthed && (
                <input
                  className="fb-email"
                  type="email"
                  placeholder="Email (optional, if you want a reply)"
                  value={guestEmail}
                  onChange={(e) => setGuestEmail(e.target.value)}
                />
              )}
              {status === "error" && <div className="fb-err">Could not send. Please try again.</div>}
              <div className="fb-actions">
                <span className="fb-note">Only the owner can read this.</span>
                <button
                  type="button"
                  className="nb-btn nb-btn-primary nb-btn-sm"
                  onClick={send}
                  disabled={status === "sending" || message.trim().length < 2}
                >
                  <FiSend size={14} /> {status === "sending" ? "Sending…" : "Send"}
                </button>
              </div>
            </>
          )}
        </div>
      )}

      <button
        type="button"
        className={`fb-fab ${open ? "open" : ""}`}
        onClick={() => setOpen((o) => !o)}
        aria-label="Send a suggestion"
        title="Send a suggestion"
      >
        {open ? <FiX size={20} /> : <FiMessageSquare size={20} />}
      </button>
    </div>
  );
}
